import { ListPlus } from "lucide-react";
import type { FC } from "react";

import { m } from "@recobra/i18n/messages";
import type { TaskType } from "@recobra/schemas/task-catalog";
import { DropdownMenuItem } from "@recobra/ui/dropdown-menu";
import { Tooltip, TooltipContent, TooltipTrigger } from "@recobra/ui/tooltip";

export const CaseTaskMenuItems: FC<{
  taskTypes: TaskType[];
  canCreatePrimary: boolean;
  disabled?: boolean;
  onSelect: (taskType?: string) => void;
}> = ({ taskTypes, canCreatePrimary, disabled = false, onSelect }) => {
  const items = canCreatePrimary ? (
    <DropdownMenuItem disabled={disabled} className="whitespace-nowrap" onClick={() => onSelect()}>
      <ListPlus />
      {m.tasks_new()}
    </DropdownMenuItem>
  ) : (
    taskTypes.map((entry) => (
      <DropdownMenuItem
        key={entry.id}
        disabled={disabled}
        className="whitespace-nowrap"
        onClick={() => onSelect(entry.id)}
      >
        <ListPlus />
        {entry.name}
      </DropdownMenuItem>
    ))
  );

  if (!disabled) return items;

  return (
    <Tooltip>
      <TooltipTrigger render={<div tabIndex={0} />}>{items}</TooltipTrigger>
      <TooltipContent>{m.task_creation_finalized_tooltip()}</TooltipContent>
    </Tooltip>
  );
};
